export default "__VITE_ASSET__BNWhbISR__"